import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from "../firebase/auth";

import { FaEnvelope, FaEye, FaEyeSlash, FaLock, FaTimes } from "react-icons/fa";

const Signin = ({onClose}) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSigningIn, setIsSigningIn]=useState(false);
  const [error, setError] = useState("");
 

  const toggleShowPassword = ()=>{
    setShowPassword(!showPassword);
  }

  const buttonRef = useRef(null);
  const handleGoogleSignInCompletion = () => {
    // Simulate some operation completion, e.g., an API call
    setTimeout(() => {
      // Auto-click the button after the operation completes
      if (buttonRef.current) {
        buttonRef.current.click();
      }
    }, 2000); // Delay to simulate operation time (2 seconds here)
  };

  useEffect(() => {
    if(isSigningIn){
      handleGoogleSignInCompletion();
      navigate('/account');
      alert("You are logged in successfully!");
    }
  }, [isSigningIn, navigate]);


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if(!isSigningIn){
        setIsSigningIn(true);
        await doSignInWithEmailAndPassword(email, password);
        navigate('/account');
        alert("You are logged in successfully!");
      }
      
    } catch (error) {
      setError(error.message);
    }
  };

  const onGoogleSignIn = (e)=> {
    e.preventDefault();
    if(!isSigningIn){
      setIsSigningIn(true);
       doSignInWithGoogle().catch(err => {
        setIsSigningIn(false);
      });
      navigate('/account');
      alert("You are logged in successfully!");
    }
  }

  return (
    <div className="absolute bg-gray-200 dark:bg-gray-900 bg-opacity-50 text-gray-400 w-full h-full top-0 p-4 lg:z-50">
      <div className="flex justify-end text-light1 ">
        <div ref={buttonRef} onClick={onClose} className="w-12 h-12 hover:text-primary rounded-full bg-light1 dark:bg-dark2 flex justify-center items-center text-gray-400">
          <FaTimes/>
        </div> 
      </div>
    <div className=" flex flex-col justify-center items-center border-light1 dark:border-dark2 bg-light2 dark:bg-dark1 border-2 mx-auto my-16 w-3/4 md:w-1/2 lg:w-1/4 rounded-lg p-4 hover:border-primary dark:hover:border-primary">
      <form onSubmit={handleLogin} className="flex flex-col">
        <h2 className="text-primary font-bold text-lg">Signin</h2>
        <hr className="m-2 border-gray-400"/>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <div className="m-2 mt-6 bg-light1 dark:bg-dark2 rounded-lg flex  w-full items-center p-2 ">
          <FaEnvelope className="mx-2"/>
          <input
            className="outline-none border-none w-3/4 mx-2 bg-light1 dark:bg-dark2"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div >
        <div className="m-2 mb-4 bg-light1 dark:bg-dark2 rounded-lg w-full flex  items-center p-2">
          <FaLock className="mx-2"/>
          <input
            className="outline-none border-none w-3/4 bg-light1 dark:bg-dark2 mx-2"
            type={showPassword?'text':'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div onClick={toggleShowPassword}>
            {showPassword? <FaEye className="mx-2"/>: <FaEyeSlash className="mx-2"/>}
          </div>
         
        </div>
        <button type="submit" className="btn m-2 w-full">{isSigningIn? 'Signing in ...' : 'Signin'}</button>
        <div className="m-2 flex items-center justify-around"> <hr className="w-1/3 border-gray-400"/> Or <hr  className="w-1/3 border-gray-400"/></div>
        <button onClick={(e)=> onGoogleSignIn(e)} type="submit" className="w-full m-2 hover:border-primary font-medium  hover:text-primary text-gray-400 border-b bg-light1 dark:bg-dark2 rounded-lg p-2">Continue with Google</button>
      </form>
    </div>
    </div>
  );
};

export default Signin;
